import { asSortParams } from "@saleor/utils/sort";
import { parseQueryString } from "@saleor/utils/urls";
import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation, useParams } from "react-router-dom";

import { WindowTitle } from "../components/WindowTitle";
import {
  StaffListUrlQueryParams,
  StaffListUrlSortField,
  StaffMemberDetailsUrlQueryParams
} from "./urls";
import StaffCreateComponent from "./views/StaffCreate";
import StaffDetailsComponent from "./views/StaffDetails";
import StaffListComponent from "./views/StaffList";

const StaffList: React.FC = () => {
  const location = useLocation();
  const qs = parseQs(location.search.substr(1));
  const params = asSortParams(
    qs,
    StaffListUrlSortField
  ) as StaffListUrlQueryParams;

  return <StaffListComponent params={params} />;
};

const StaffDetails: React.FC = () => {
  const location = useLocation();
  const { id } = useParams();
  const params = parseQueryString<StaffMemberDetailsUrlQueryParams>(
    location.search.substr(1)
  );

  return <StaffDetailsComponent id={decodeURIComponent(id)} params={params} />;
};

const Component = () => {
  const intl = useIntl();

  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Users"
        })}
      />
      <Routes>
        <Route path={""} element={<StaffList />} />
        <Route path={"add"} element={<StaffCreateComponent />} />
        <Route path={":id"} element={<StaffDetails />} />
      </Routes>
    </>
  );
};

export default Component;
